module.exports = __webpack_public_path__ + "img/Carrousels STARTO_rdv_slide_1.b1dcd083.png";